export async function generateSiteId(siteName: string) {
  if (siteName.toLowerCase().endsWith('ess')) {
    siteName = siteName.slice(0, -3);
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(siteName);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');

  const prefix = Array.from(hex.slice(0, 2))
    .map((c) => String.fromCharCode((parseInt(c, 16) % 26) + 65))
    .join('');

  const suffix = Array.from(hex.slice(2, 6))
    .map((c) => (parseInt(c, 16) % 10).toString())
    .join('');

  return prefix + suffix;
}

export const makeStringToDecimalString = (
  floatString: string,
  decimalNumber: number,
  isLocaleString: boolean = false
) => {
  const decimal = Math.pow(10, decimalNumber);
  const parsedNumber = Math.round(parseFloat(floatString) * decimal) / decimal;
  return isLocaleString
    ? parsedNumber.toLocaleString()
    : parsedNumber.toString();
};

const findKeyByValue = (
  obj: { [key: string]: string },
  value: string
): string | null => {
  return Object.entries(obj).find(([_, val]) => val === value)?.[0] || null;
};

const getSVGPath = (SVGName: string) => {
  return `/assets/${SVGName}.svg`;
};

const hexToRgb = (hex: string) => {
  // Remove the hash (#) if it exists
  hex = hex.replace(/^#/, '');

  // Parse into RGB components
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return `rgb(${r}, ${g}, ${b})`;
};

// Convert hex to rgb with opacity for check tailwind style in test
const hexToRgbWithOpacity = (
  hex: string,
  opacityVar = 'var(--tw-bg-opacity, 1)'
) => {
  // Remove the hash (#) if it exists
  hex = hex.replace(/^#/, '');

  // Parse the hex color string into RGB components
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  // Return the formatted string in the desired format
  return `rgb(${r} ${g} ${b} / ${opacityVar})`;
};

function isEnumValue<T extends Record<string, unknown>>(
  enumObj: T,
  value: unknown
): value is T[keyof T] {
  return Object.values(enumObj).includes(value as T[keyof T]);
}

export {
  findKeyByValue,
  getSVGPath,
  hexToRgb,
  hexToRgbWithOpacity,
  isEnumValue,
};
